//保全类别
let columns = [
    {keyId: 1, text: "诉前保全"},
    {keyId: 2, text: "诉讼保全"},
]

//保全类别
let columnsBQLB = [
    {keyId: 1, text: "诉前保全"},
    {keyId: 2, text: "诉讼保全"},
    {keyId: 3, text: "仲裁保全"},
    {keyId: 4, text: "执行前保全"},
]

// 申请人类型
let columnsSQR = [
    {keyId: 1, text: "申请人"},
    {keyId: 2, text: "律师"},
    {keyId: 3, text: "其他代理人"},
]

//案件类型
let columnsAjlx = [
    {keyId: 1, text: "刑事"},
    {keyId: 2, text: "民事"},
    {keyId: 6, text: "行政"},
]

//担保情况
let columnsDbqk = [
    {keyId: 1, text: "有担保"},
    // {keyId: 2, text: "无担保"},
    {keyId: 3, text: "无需担保"},
]
//诉前保全-担保情况
let columnsSQBQDbqk = [
    {keyId: 1, text: "有担保"},
    {keyId: 2, text: "无担保"}
]

//保全类型
let columnsBqlx = [
    {keyId: 1, text: "财产保全"},
    // 目前版本只显示财产保全 2019/10/22
    { keyId: 2, text: "证据保全" },
    { keyId: 3, text: "行为保全" },
]

//担保保全类型(担保只有财产保全)
let columnsDbBqlx = [
    {keyId: 1,text: "财产保全"}
]

//担保方式
let columnsDBFS = [
    {keyId: '5', text: "保险公司诉责险"},
    {keyId: '1', text: "交纳保证金"},
    {keyId: '2', text: "提供保证人"},
    // 1.0PC端没有展示提供担保物
    // { keyId: 2, text: "提供担保物" },
    {keyId: '3', text: "设定抵押"},
    {keyId: '4', text: "设定质押"},
]

//担保变更事项
let columnsDBBGSX = [
    {keyId: 1, text: "申请减少担保"},
    {keyId: 2, text: "申请变更担保"},
    {keyId: 3, text: "申请取消担保"},
]

//线上情况下的变更事项
let columnsXSBG = [
    {keyId: 2, text: "申请变更担保"},
    {keyId: 3, text: "申请取消担保"},
]


//非诉期间
let columnsFsqj = [
    {keyId: 1, text: "未起诉或提起仲裁前"},
    // 当前版本只显示未注释部分 2019/10/22
    // { keyId: 2, text: "仲裁审理期间" },
    // { keyId: 3, text: "上诉后二审法院接收移送案件前" },
    // { keyId: 4, text: "法律文书生效后进入执行程序前" },
    // { keyId: 5, text: "外国法院审理期间" },
    // { keyId: 6, text: "申请认可与执行香港特区法院裁判或仲裁裁决受理前" },
    // { keyId: 7, text: "申请认可与执行澳门特区法院裁判或仲裁裁决受理前" },
    // { keyId: 8, text: "申请认可与执行台湾地区法院裁判或仲裁裁决受理前" },
    // { keyId: 255, text: "其他非诉期间" },
]

//保险公司
let columnsBxgs = [
    // {keyId: "001", text: "中国人民财产保险股份有限公司"},
    {keyId: "002", text: "中国平安财产保险股份有限公司"},
    // 20191105 需求要求去除众安
    // { keyId: "003", text: "众安在线财产保险股份有限公司" },
]

//101000 人员类型
let columnsRYLX = [
    {keyId: '1', text: "自然人"},
    {keyId: '2', text: "法人"},
    {keyId: '3', text: "非法人组织"},
]

// 102000	当事人及主要涉案人类型
let columnsSARLX = [
    {keyId: 1, text: "当事人"},
    {keyId: 2, text: "法定代理人"},
    {keyId: 3, text: "代理人"},
    {keyId: 4, text: "辩护人"},
    {keyId: 5, text: "法定代表人"},
    {keyId: 6, text: "负责人"},
    {keyId: 7, text: "诉讼代表人"},
    {keyId: 8, text: "证人"},
    {keyId: 9, text: "鉴定人"},
    {keyId: 10, text: "有专门知识的人"},
    {keyId: 11, text: "翻译人员"},
    {keyId: 12, text: "勘验人员"},
    {keyId: 13, text: "参与分配申请人"},
    {keyId: 14, text: "担保人"},
    {keyId: 15, text: "协助执行义务人"},
    {keyId: 16, text: "到期债权债务人"},
    {keyId: 17, text: "直接责任人"},
    {keyId: 18, text: "利害关系人"},
    {keyId: 19, text: "被害人"},
    {keyId: 255, text: "其他"},
]

//103000	代理人类型
let columnsDLRLX = [
    {keyId: 1, text: "执业律师"},
    {keyId: 2, text: "基层法律服务工作者"},
    {keyId: 3, text: "当事人的近亲属或工作人员"},
    {keyId: 4, text: "当事人所在社区、单位以及有关社会团体推荐的公民"},
    {keyId: 5, text: "经赔偿委员会许可的其他公民"},
]

//104000	辩护人类型
let columnsBHR = [
    {keyId: 1, text: "执业律师"},
    {keyId: 2, text: "人民团体或者被告人所在单位推荐的人"},
    {keyId: 3, text: "被告人的监护人、亲友"},
]

// 105000	身份证件类型
let columnsSFZ = [
    {keyId: 1, text: "居民身份证"},
    {keyId: 2, text: "中国公民护照"},
    {keyId: 3, text: "台湾居民来往大陆通行证"},
    {keyId: 4, text: "港澳居民来往内地通行证"},
    {keyId: 5, text: "外国公民护照"},
    {keyId: 6, text: "户口簿"},
    {keyId: 255, text: "其他"},
]

// 106000	行为能力状况
let columnsXWNL = [
    {keyId: 1, text: "完全行为能力"},
    {keyId: 2, text: "限制行为能力"},
    {keyId: 3, text: "无行为能力"},
]

// 107000	刑事责任能力
let columnsXSZR = [
    {keyId: 1, text: "完全刑事责任能力"},
    {keyId: 2, text: "限制刑事责任能力"},
    {keyId: 3, text: "无刑事责任能力"},
]

// 108000	工作单位类型
let columnsGZDW = [
    {keyId: 1, text: "机关"},
    {keyId: 2, text: "事业单位"},
    {keyId: 3, text: "企业"},
    {keyId: 4, text: "社会团体"},
    {keyId: 5, text: "民办非企业单位"},
    {keyId: 255, text: "其他"},
]

// 110000	性别
let columnsXB = [
    {keyId: 0, text: "未知的性别"},
    {keyId: 1, text: "男性"},
    {keyId: 2, text: "女性"},
    {keyId: 9, text: "未说明的性别"},
]

// 111000	婚姻状况
let columnsHYZK = [
    {keyId: 10, text: "未婚"},
    {keyId: 20, text: "已婚"},
    {keyId: 21, text: "初婚"},
    {keyId: 22, text: "再婚"},
    {keyId: 23, text: "复婚"},
    {keyId: 30, text: "丧偶"},
    {keyId: 40, text: "离婚"},
    {keyId: 90, text: "未说明的婚姻状况"},
]

// 112000	财产类型
let columnsCCLX = [
    {keyId: 1, text: "现金"},
    {keyId: 2, text: "银行存款"},
    {keyId: 3, text: "车辆"},
    {keyId: 4, text: "房产"},
    {keyId: 5, text: "土地"},
    {keyId: 6, text: "股票"},
    {keyId: 7, text: "基金"},
    {keyId: 8, text: "债券"},
    {keyId: 9, text: "股权"},
    /* { keyId: 10, text: "税务" },*/
    {keyId: 255, text: "其他"},
]

// 车辆类型
let columnsCLLX = [
    {keyId: 1, text: "新能源汽车"},
    {keyId: 2, text: "微型汽车"},
    {keyId: 3, text: "小型汽车"},
    {keyId: 4, text: "紧凑型汽车"},
    {keyId: 5, text: "中型汽车"},
    {keyId: 6, text: "中大型汽车"},
    {keyId: 7, text: "大型汽车"},
    {keyId: 8, text: "SUV"},
    {keyId: 9, text: "MPV"},
    {keyId: 10, text: "跑车"},
    {keyId: 255, text: "其他"},
]

//提交人类型
let columnsTJR = [
    {keyId: 1, text: "申请人"},
    {keyId: 2, text: "律师"},
    {keyId: 3, text: "其他代理人"},
]

// 119000	币种
let columnsBZ = [
    {keyId: 1, text: "人民币"},
    {keyId: 2, text: "港币"},
    {keyId: 3, text: "美元"},
    {keyId: 4, text: "英镑"},
    {keyId: 5, text: "欧元"},
]
// 131000   土地单位
let columnsTDDW = [
    {keyId: 1, text: "平方米"},
    {keyId: 2, text: "公顷"},
    {keyId: 3, text: "平方千米"},
]

//无需担保原因
let columnsWxdb = [
    {keyId: 1, text: "追索赡养费、抚养费、抚育费、抚恤金、医疗费用、劳动报酬、工伤赔偿、交通事故人身损害赔偿的"},
    {keyId: 2, text: "婚姻家庭纠纷案中遭遇家庭暴力且经济困难的"},
    {keyId: 3, text: "人民检察院提起的公益诉讼涉及损害赔偿的"},
    {keyId: 4, text: "因见义勇为遭受侵害请求损害赔偿的"},
    {keyId: 5, text: "案件事实清楚、权利义务关系明确，发生保全错误可能性较小的"},
    {keyId: 6, text: "申请保全人为商业银行、保险公司等由金融监管部门批准设立的具有独立偿付债务能力的金融机构及其分支机构的"},
]

//复议事项
let columnsFYSX = [
    {keyId: 1, text: "财产保全审查的裁定"},
    {keyId: 2, text: "行为保全审查的裁定"},
    {keyId: 3, text: "证据保全审查的裁定"},
]

//复议案件类型
let columnsFYAJLX = [
    // {keyId: 1, text: "非诉"},
    // {keyId: 2, text: "刑事"},
    // {keyId: 3, text: "民事"},
    // {keyId: 4, text: "行政"},
]

//复议诉讼地位
let columnsSSDW = [
    {keyId: 1, text: "原申请人"},
    {keyId: 2, text: "原被申请人"},
]

//案号年份
let columnsAhnf = [
    {keyId:1, text:"2020"},
    {keyId:2, text:"2019"},
    {keyId:3, text:"2018"}
]

//省份
let columnsSF = [
    {
        text: '北京',
        keyId: '1'
    },
    {
        text: '天津',
        keyId: '2'
    },
    {
        text: '河北',
        keyId: '3'
    },
    {
        text: '山西',
        keyId: '4'
    },
    {
        text: '内蒙古',
        keyId: '5'
    },
    {
        text: '辽宁',
        keyId: '6'
    },
    {
        text: '吉林',
        keyId: '7'
    },
    {
        text: '黑龙江',
        keyId: '8'
    },
    {
        text: '上海',
        keyId: '9'
    },
    {
        text: '江苏',
        keyId: '10'
    },
    {
        text: '浙江',
        keyId: '11'
    },
    {
        text: '安徽',
        keyId: '12'
    },
    {
        text: '福建',
        keyId: '13'
    },
    {
        text: '江西',
        keyId: '14'
    },
    {
        text: '山东',
        keyId: '15'
    },
    {
        text: '河南',
        keyId: '16'
    },
    {
        text: '湖北',
        keyId: '17'
    },
    {
        text: '湖南',
        keyId: '18'
    },
    {
        text: '广东',
        keyId: '19'
    },
    {
        text: '广西',
        keyId: '20'
    },
    {
        text: '海南',
        keyId: '21'
    },
    {
        text: '重庆',
        keyId: '22'
    },
    {
        text: '四川',
        keyId: '23'
    },
    {
        text: '贵州',
        keyId: '24'
    },
    {
        text: '云南',
        keyId: '25'
    },
    {
        text: '西藏',
        keyId: '26'
    },
    {
        text: '陕西',
        keyId: '27'
    },
    {
        text: '甘肃',
        keyId: '28'
    },
    {
        text: '青海',
        keyId: '29'
    },
    {
        text: '宁夏',
        keyId: '30'
    },
    {
        text: '新疆',
        keyId: '31'
    },
]

// 120000	民族
let columnsMZ = [
    {
        text: '汉族',
        keyId: '1'
    },
    {
        text: '蒙古族',
        keyId: '2'
    },
    {
        text: '回族',
        keyId: '3'
    },
    {
        text: '藏族',
        keyId: '4'
    },
    {
        text: '维吾尔族',
        keyId: '5'
    },
    {
        text: '苗族',
        keyId: '6'
    },
    {
        text: '彝族',
        keyId: '7'
    },
    {
        text: '壮族',
        keyId: '8'
    },
    {
        text: '布依族',
        keyId: '9'
    },
    {
        text: '朝鲜族',
        keyId: '10'
    },
    {
        text: '满族',
        keyId: '11'
    },
    {
        text: '侗族',
        keyId: '12'
    },
    {
        text: '瑶族',
        keyId: '13'
    },
    {
        text: '白族',
        keyId: '14'
    },
    {
        text: '土家族',
        keyId: '15'
    },
    {
        text: '哈尼族',
        keyId: '16'
    },
    {
        text: '哈萨克族',
        keyId: '17'
    },
    {
        text: '傣族',
        keyId: '18'
    },
    {
        text: '黎族',
        keyId: '19'
    },
    {
        text: '傈僳族',
        keyId: '20'
    },
    {
        text: '佤族',
        keyId: '21'
    },
    {
        text: '畲族',
        keyId: '22'
    },
    {
        text: '高山族',
        keyId: '23'
    },
    {
        text: '拉祜族',
        keyId: '24'
    },
    {
        text: '水族',
        keyId: '25'
    },
    {
        text: '东乡族',
        keyId: '26'
    },
    {
        text: '纳西族',
        keyId: '27'
    },
    {
        text: '景颇族',
        keyId: '28'
    },
    {
        text: '柯尔克孜族',
        keyId: '29'
    },
    {
        text: '土族',
        keyId: '30'
    },
    {
        text: '达斡尔族',
        keyId: '31'
    },
    {
        text: '仫佬族',
        keyId: '32'
    },
    {
        text: '羌族',
        keyId: '33'
    },
    {
        text: '布朗族',
        keyId: '34'
    },
    {
        text: '撒拉族',
        keyId: '35'
    },
    {
        text: '毛南族',
        keyId: '36'
    },
    {
        text: '仡佬族',
        keyId: '37'
    },
    {
        text: '锡伯族',
        keyId: '38'
    },
    {
        text: '阿昌族',
        keyId: '39'
    },
    {
        text: '普米族',
        keyId: '40'
    },
    {
        text: '塔吉克族',
        keyId: '41'
    },
    {
        text: '怒族',
        keyId: '42'
    },
    {
        text: '乌孜别克族',
        keyId: '43'
    },
    {
        text: '俄罗斯族',
        keyId: '44'
    },
    {
        text: '鄂温克族',
        keyId: '45'
    },
    {
        text: '德昂族',
        keyId: '46'
    },
    {
        text: '保安族',
        keyId: '47'
    },
    {
        text: '裕固族',
        keyId: '48'
    },
    {
        text: '京族',
        keyId: '49'
    },
    {
        text: '塔塔尔族',
        keyId: '50'
    },
    {
        text: '独龙族',
        keyId: '51'
    },
    {
        text: '鄂伦春族',
        keyId: '52'
    },
    {
        text: '赫哲族',
        keyId: '53'
    },
    {
        text: '门巴族',
        keyId: '54'
    },
    {
        text: '珞巴族',
        keyId: '55'
    },
    {
        text: '基诺族',
        keyId: '56'
    },
]

// 抵押财产类型
let columnsDycclx = [
    {keyId: 4, text: "房产"},
    {keyId: 5, text: "土地"},
    {keyId: 6, text: "车辆"},
    {keyId: 7, text: "机械设备"},
    {keyId: 8, text: "现金"},
    {keyId: 9, text: "存款"},
]

// 有效期列表
const columnIsndate = [
    {keyId: 1, text: '长期有效'},
    {keyId: 2, text: '有效期至...'}
]
//行为保全事项
let columnsXWSX = [
    {keyId: 1, text: "中止支付信用证项下款项"},
    {keyId: 2, text: "中止支付保函项下款项"},
    {keyId: 3, text: "停止侵犯知识产权"},
    {keyId: 5, text: "申请责令被申请人作出一定行为"},
    {keyId: 255, text: "其他"},
]

//证据类型
let columnsZJLX = [
    {keyId: 1, text: "当事人陈述"},
    {keyId: 2, text: "被害人陈述"},
    {keyId: 3, text: "犯罪嫌疑人、被告人供述和辩解"},
    {keyId: 4, text: "书证"},
    {keyId: 5, text: "物证"},
    {keyId: 6, text: "视听资料"},
    {keyId: 7, text: "电子数据"},
    {keyId: 8, text: "证人证言"},
    {keyId: 9, text: "鉴定意见"},
    {keyId: 10, text: "勘验、检查、辨认、侦查实验等笔录"},
    {keyId: 255, text: "其他"},
]

export {
    columns,
    columnsSQR,
    columnsRYLX,
    columnsSARLX,
    columnsDLRLX,
    columnsBHR,
    columnsSFZ,
    columnsXWNL,
    columnsXSZR,
    columnsGZDW,
    columnsXB,
    columnsHYZK,
    columnsCCLX,
    columnsCLLX,
    columnsTJR,
    columnsBZ,
    columnsMZ,
    columnsAjlx,
    columnsDbqk,
    columnsSQBQDbqk,
    columnsBqlx,
    columnsBxgs,
    columnsFsqj,
    columnsTDDW,
    columnsDBFS,
    columnsDBBGSX,
    columnsXSBG,
    columnsDycclx,
    columnsWxdb,
    columnsFYSX,
    columnsFYAJLX,
    columnsSSDW,
    columnsXWSX,
    columnsZJLX,
    columnsBQLB,
    columnsAhnf,
    columnIsndate
}
